const empDataAjax = (function () {
    async function getEmployeeDataWidgetAsync(reqData) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getEmployeeDataWidget/',
                data: JSON.stringify(reqData),                   
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });

            return JSON.parse(result.getEmployeeDataWidgetResult);
        } catch (error) {
            throw new Error(error.responseText);
        }
    }
    async function getEmployeeDataCategoriesAsync() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getEmployeeDataCategories/',
                data: JSON.stringify({token: $.session.Token}),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });

            return JSON.parse(result.getEmployeeDataCategoriesResult);
        } catch (error) {
            throw new Error(error.responseText);
        }
    }
    async function getEmployeeToEmailAsync() {
        try {
            const data = {
                token: $.session.Token
            }
            const result = await $.ajax({
                type: 'POST',
                url: $.webServer.protocol + '://' + $.webServer.address + ':' + $.webServer.port + '/' + $.webServer.serviceName + '/getEmployeeToEmailDropDown/',
                data: JSON.stringify(data),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result.getEmployeeToEmailDropDownResult;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }
    async function sendEmailWithAttachmentAsync(payload) {

        const data = {
            token: $.session.Token,
            toAddresses: payload.toAddresses,
            ccAddresses: payload.ccAddresses,
            bccAddresses: payload.bccAddresses,
            emailSubject: payload.emailSubject,
            emailBody: payload.emailBody,
            attachmentType: payload.attachmentType,
            attachmentName: payload.attachmentName,
            attachment: payload.attachment
        }
        return await $.ajax({
            type: 'POST',
            url: $.webServer.protocol + '://' + $.webServer.address + ':' + $.webServer.port + '/' + $.webServer.serviceName + '/sendEmployeeDataEmail/',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        });
    }

    return{
        getEmployeeDataWidgetAsync,
        getEmployeeDataCategoriesAsync,
        getEmployeeToEmailAsync,
        sendEmailWithAttachmentAsync
    }

})();
